<template>
<div class="blue_background">
  <div class="row align-center">
    <div class="small-12 medium-11 large-9 columns wrappercontent">
      <h3>{{ $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_TITULO") }}</h3>
      <div class="form_fundo" v-if="!submetido">
        <form class="estudoform" method="post" @submit="onSubmit" novalidate>
          <input type="checkbox" 
            name="enviarPorEmail"
            value="0" 
            @v-model="formFieldEnviarEmail"
            style="display:none !important" tabindex="-1" autocomplete="off">
          <input type="text" 
            name="morada" 
            @v-model="formFieldMorada" 
            value="rua nova do funchal"
            style="display:none !important" tabindex="-1" autocomplete="off">
          <div class="row">
            <div class="small-12 medium-12 large-12 columns">
              <p class="disclaimer">{{ $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_PROTECAO") }}</p>
            </div>
          </div>
          <div class="row">
            <div class="columns"
              :class="formElement.config.classname" 
              :key="name"
              v-for="(formElement, name) in form">
                <FormInput
                  :name="name"
                  :formElement="formElement"
                  :form="form"
                  :validate="validate" />
            </div>
          </div>
          <div class="row botoes_pedido_divulgacao">
            <router-link class="cancelbtn" to="/alojamento">
              {{ $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_CANCELAR") }}
            </router-link>
            <button class="formsubmit" :class="{ 'disabled': isFormDisabled() }" :disabled="isFormDisabled()"
              type="submit">{{
                $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUBMETER") }}
            </button>
          </div>
        </form>
      </div>
      <div v-if="submetido" class="form_fundo">
        <router-link class="backsubmit" to="/alojamento">
          <i class="closeResults ms-Icon ms-Icon--ChromeClose"></i>
        </router-link>
        <div class="estudoform">
          <p class="msgsucess">
            <i class="fa fa-check" aria-hidden="true"></i>
            {{ $t("form.UMA_LANG_SASUMA_ALOJAMENTO_FORM_SUCCESS") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "@/axios";
import axioswp from "@/axioswp";
import { ref } from "vue";
import { i18n } from "@/main.js";
import { onBeforeRouteLeave } from 'vue-router';
import { useFormStore } from '@/stores/form.js'
import FormInput from "@/components/FormInput.vue";


export default {
  props:["candidatura"],
  components:{
    FormInput
  },
  setup(props) {

    const { t } = i18n.global;

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    const form = ref({
      concurso: {
        config: {
          type: 'select',
          label: t('formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_CONCURSO'),
          classname: 'small-12 medium-12 large-12',
          options: []
        },
        value: "",
        touched: "",
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      nomecompleto: {
        config: {
          type: 'text',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_NOMECOMPLETO"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: "",
        rules: {
          required: true
        },
        isValid: false,
        errors: []
      },
      numeroaluno: {
        config: {
          type: 'text',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_NUMALUNO"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: "",
        rules: {},
        errors: [],
        isValid: true
      },
      distrito: {
        config: {
          type: 'text',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_DISTRITO"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      localidade: {
        config: {
          type: 'text',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_LOCALIDADE"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      alunouma: {
        config: {
          type: 'select',
          options: [
            { label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_SIM"), value: "Sim" },
            { label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_NAO"), value: "Não" },
          ],
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_EALUNO"),
          classname: 'small-12 medium-12 large-12',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      telemovel: {
        config: {
          type: 'text',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_TELEMOVEL"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      email: {
        config: {
          type: 'email',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_EMAIL"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          isEmail: true,
          required: true
        },
        errors: [],
        isValid: false
      },
      dataentrada: {
        config: {
          type: 'date',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATAENTRADA"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      },
      datasaida: {
        config: {
          type: 'date',
          label: t("formfield.UMA_LANG_SASUMA_ALOJAMENTO_FORM_DATASAIDA"),
          classname: 'small-12 medium-6 large-6',
        },
        value: "",
        touched: false,
        rules: {
          required: true
        },
        errors: [],
        isValid: false
      }
    })

    const formIsValid = ref(false);
    const formFieldEnviarEmail = ref("1");
    const formFieldMorada = ref("");
    const submetido = ref(false);

    const store = useFormStore();

    axios.get("/sas/alojamento/tiposconcursos").
      then(response => {
        form.value.concurso = {
          ...form.value.concurso,
          config:{
            ...form.value.concurso.config,
            options: response.data
          },
          isValid: true,
          value: store.currentform ?? response.data[0].value
        }
      }).
      catch(error => {
        console.log(error);
      })

    const validate = prop => {
      const rules = form.value[prop].rules;
      var isValid = true;
      var errors = [];
      if (rules.required) {
        if (form.value[prop].value.length == 0) {
          isValid = false;
          errors.push("O campo é de preenchimento obrigatório");
        }
      }
      if (rules.isEmail) {
        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        isValid = pattern.test(form.value[prop].value) && isValid;
        if (!pattern.test(form.value[prop].value)) {
          errors.push("Introduza um valor com o formato de email");
        }
      }
      if (rules.url) {
        const pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
        isValid = pattern.test(form.value[prop].value) && isValid;
        if (!pattern.test(form.value[prop].value)) {
          errors.push("O url introduzido não é válido");
        }
      }
      if (rules.isNumber) {
        if (isNaN(form.value[prop].value)) {
          errors.push("Introduza um número válido");
          isValid = false;
        }
      }
      form.value[prop].isValid = isValid;
      form.value[prop].errors = errors;
    }

    const isFormDisabled = () => {
      let val = true;
      for (const [key, value] of Object.entries(form.value)) {
        val = val && form.value[key].isValid;
      }
      if (formFieldEnviarEmail.value != "1" || formFieldMorada.value != "") {
        return true
      }
      return !val;
    }

    const concursos = [
      {value:"recandidatura",label:"Recandidatura"},
      {value:"mobilidade",label:"Mobilidade"},
      {value:"internacional",label:"Internacional"},
      {value:"novosalunos",label:"Novos Alunos"},
    ];

    const onSubmit = e => {
      e.preventDefault();
      const result = {};
      for (let [key, value] of Object.entries(form.value)) {
        result[key] = value.value;
      }
      result.concurso = concursos.find(el => el.value ==  result.concurso);
      axioswp.post("/sas/registercandidatura",result).
        finally(() => {
          submetido.value = true;
          window.scrollTo(0,0);
        });
    }

    return {
      onSubmit,
      isFormDisabled,
      validate,
      form,
      formIsValid,
      formFieldEnviarEmail,
      formFieldMorada,
      submetido
    }
  }
}
</script>

<style lang="scss" scoped>
/*#region formulário*/
.wrappercontent {
  max-width: 100rem;
  margin-bottom: 200px;
  margin-top: 40px;
}

.wrappercontent h3 {
  padding-top: 40px;
  letter-spacing: -1.5px;
  font-size: 38px;
  text-align: center;
  color: white;
  font-family: 'Montserrat';
  padding-bottom: 8px;
}

.wrappercontent h4 {
  padding-top: 8px;
  letter-spacing: -1.5px;
  font-size: 20px;
  text-align: center;
  color: white;
  font-family: 'Montserrat Bold';
  padding-bottom: 30px;
}

.form_fundo {
  background-color: white;
  position: relative;
}

.form_fundo .estudoform {
  padding: 60px 70px 80px 70px;
}

.estudoform .disclaimer {
  font-family: "Montserrat";
  color: rgb(62, 62, 62);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.8;
}

.estudoform .row .columns {
  margin-bottom: 40px;
}

.estudoform .confirmation {
  margin-top: 20px;
  margin-bottom: 20px;
}

.estudoform .filebutton {
  background: #6eb7ec;
  color: white;
}

.estudoform .accordion-content {
  padding-left: 0;
  padding-right: 0;
}

.estudoform .accordion-title:before {
  content: '\f078';
  font-family: FontAwesome;
  font-size: 18px;
  margin-top: -12px;
}

.estudoform .accordion-item.is-active .accordion-title:before {
  content: '\f077';
}

.formsubmit {
  margin-top: 40px;
  background-color: #6eb7ec;
  color: white;
  font-family: 'Montserrat Bold', serif;
  border: 0px solid white;
  text-align: center;
  text-transform: uppercase;
  font-size: 15px;
  letter-spacing: 0.5px;
  padding: 21px 45px;
}

.formsubmit.disabled {
  background-color: #cccccc;
}

.estudoform .error {
  color: red;
}

.estudoform img.pdf_icon {
  height: 30px;
  display: flex;
  margin: 0;
  margin-right: 10px;
}

.msgsucess {
  font-family: "Montserrat SemiBold";
  font-size: 25px;
  padding-bottom: 18px;
  color: #3a3a3a;
  padding-left: 0;
  padding-right: 0;
}

.backto,
.backto:hover {
  margin-top: 40px;
  background-color: #6eb7ec;
  color: white;
  font-family: 'Montserrat Bold', serif;
  border: 2px solid white;
  text-align: center;
  text-transform: uppercase;
  font-size: 15px;
  letter-spacing: 0.5px;
  padding: 21px 45px;
}

.authorization,
.authorization:hover {
  display: flex;
  align-items: center;
  font-family: "Montserrat";
  color: rgb(134 130 132);
  font-size: 15px;
}

.botoes_pedido_divulgacao {
  text-align: right;
  display: block;
}

.botoes_pedido_divulgacao .cancelbtn {
  margin-right: 10px;
}

.estudoform .cancelbtn,
.estudoform .cancelbtn:hover {
  margin-top: 40px;
  background-color: #5a6269;
  color: white;
  font-family: 'Montserrat Bold', serif;
  border: 0px solid white;
  text-align: center;
  text-transform: uppercase;
  font-size: 15px;
  letter-spacing: 0.5px;
  padding: 19px 45px;
  margin-left: 20px;
}

.blue_background {
  background-color: #4a9db6;
}

@media (max-width: 767px) {

  .formsubmit,
  .estudoform .cancelbtn,
  .estudoform .cancelbtn:hover {
    font-size: 12px;
    width: 100%;
  }

  .estudoform .cancelbtn,
  .estudoform .cancelbtn:hover {
    display: flex;
    margin-left: 0;
    justify-content: center;
  }

  .large-9 {
    flex: 0 0 100%;
  }

}

.msgsucess {
  font-family: "Montserrat";
  font-size: 20px;
  padding-bottom: 18px;
  color: #3a3a3a;
  padding-left: 0;
  padding-right: 0;
  display: flex;
  align-items: center;
}

.msgsucess i {
  font-size: 35px;
  color: green;
  margin-right: 10px;
}

.backsubmit {
  font-size: 22px;
  position: absolute;
  right: 20px;
  top: 20px;
  color: #484747;
}

/*#endregion*/
</style>